module.exports = ".alignData {\n  margin-left: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/icb/t2c/confirm/confirm.component.scss
// module id = 897
// module chunks = 10